import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import Grid from '@material-ui/core/Grid';

import { AppConfig } from '../../AppConfig';
import { CommonStyles } from '../../styles/Styles';
import Icon from '@material-ui/core/Icon';
import Tooltip from '@material-ui/core/Tooltip';
import { Button, Divider } from '@material-ui/core';
import { data } from '../../data/AdminData.js'
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import { Link } from 'react-router-dom';
import { ApiHelper } from '../../common/helpers/ApiHelper';
import { UiHelper } from '../../common/helpers/UiHelper';
import InputLabel from '@material-ui/core/InputLabel';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MomentUtils from '@date-io/moment';
import moment from 'moment';
import momentTz from 'moment-timezone';
import { DateTimePicker, MuiPickersUtilsProvider } from 'material-ui-pickers'; //NOTE: made changes in lib corresponding to the issue: https://github.com/viict/material-ui-pickers/commit/96af9c855df51fc0b96a9bd6f7b22684d47a7043
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import CircularProgress from '@material-ui/core/CircularProgress';
import { EventList } from '../../common/components/EventList';
import IconButton from '@material-ui/core/IconButton';
import { EventDialogFunction } from '../../common/components/EventDialogFunction';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import { JcropService } from '../../common/helpers/JcropService';
import { ApiHelperV2 } from '../../common/helpers/ApiHelperV2';
import { Helper } from '../../common/helpers/Helper';
import { Controller } from '../../common/Controller';
import { Styles } from './Styles';
//import * as queryString from 'query-string';
import * as urlParser from 'url-parse';
import * as qs from 'qs';
import Fab from '@material-ui/core/Fab';
import { EventVideoList } from '../../common/components/EventVideoList';
import { EventVideoDialogFunction } from '../../common/components/EventVideoDialogFunction';
import { DialogMsg } from '../../common/components/DialogMsg';
import { LiveImage } from '../../common/components/LiveImage';
import { StatCard } from '../../common/components/StatCard';

import '../../assets/jcrop.css'
import { Jcrop } from '../../assets/jcrop';
import { AppTheme } from '../../styles/AppTheme';

const queryString = require('query-string');

//TODO: something with additionalImages (search in angular project)
export class ClientPlacesDetails extends Component {
  constructor(props) {
    super(props);
    if (props.location) {
      this.queryParams = queryString.parse(props.location.search);
    }
    this.eventsLimit = AppConfig.eventQueryLimit;
    this.imageFeedRefreshInterval = AppConfig.imageFeedRefreshInterval;
    this.eventRefreshInterval = AppConfig.eventRefreshInterval;
    this.eventUpdateIntervalFnId = null;
    this.updateImageIntervalFnId = null;
    this.userSettings = Controller.get().userMgrV2().getUserSettings()
    this.eventPriorityValue = Number(this.userSettings.EVENT_VISIBILITY);
    this.placeData = data
    this.slug = this.props.match.params.id ? this.props.match.params.id : null;
    this.targetImageWidth = 0;
    this.targetImageHeight = 0;
    this.refreshWithLast24hrs = true
    this.dateDialogClosed = true
    this.fetechedCamEvents = []
    this.showLiveStreamsStile = this.queryParams ? this.queryParams.showlive : null
    this.state = {
      pageNumber: 0,
      restoreUpdate: false,
      autoUpdate: AppConfig.showAutoUpdateToggle ? false : true,
      eventsReady: false,
      videosReady: false,
      eventLatest: null,
      statAdjust: 0,
      statUpdateInProcess: false,
      parkingEntry: { IN: 0, OUT: 0, PARKED: 0 },
      parkingEntryTotal: { IN_TOTAL: 0, OUT_TOTAL: 0 },
      eventData: [],
      videoData: [],
      cams: [],
      selectedCam: null,
      urlJpeg: null,
      selectedCamId: (this.queryParams && this.queryParams.camId) ? this.queryParams.camId : null,
      fromEventDate: moment().subtract(1, 'days').valueOf(),
      toEventDate: moment().valueOf(),
      search: '',
      event: AppConfig.camLiveTab ? false : true,
      live: AppConfig.camLiveTab ? true : false,
      events: true,
      video: false,
      eventIndex: 0,
      liveStream: false,

      roiDialog: false,
      dialogAction: '',
      dialogTitle: '',
      roiTitle: '',
      roiValue: '',
      roiDelete: '',
      showDeleteWarning: false,

      showROI: false,
      slideChecked: false,
      viewMode: 'ROI OFF',

      fetchState: ApiHelperV2.State.LOADING,
      formFieldsValidity: {
        roiTitle: true,
        roiValue: true,
      },
      formFieldErrMsg: {
        roiTitle: '*Required',
        roiValue: '*Required',
      },
      parkedVal: 0,
      statDialog: false,
      statFieldErrMsg: null
    },
    this.statFields = {
      parkedVal: {
        key: 'parkedVal',
        label: 'PARKED',
        type: 'text'
      }
    }
    this.orgFields = {
      roiTitle: {
        key: 'roiTitle',
        label: 'Title',
        type: 'text'
      },
      roiValue: {
        key: 'roiValue',
        label: 'Value',
        type: 'text'
      },
      roiDelete: {
        key: 'roiDelete',
        label: 'Type DELETE',
        type: 'text'
      }
    };
    this.placeFields = {
      selectCam: {
        key: 'selectedCamId',
        label: 'Select Cam',
        type: 'text'
      },
      fromEventDate: {
        key: 'fromEventDate',
        label: 'From',
        type: 'text'
      },
      toEventDate: {
        key: 'toEventDate',
        label: 'To',
        type: 'text'
      },
      search: {
        key: 'search',
        label: 'Search',
        type: 'text'
      },
    }
  }

  componentDidMount() {
    this.fetchItems();
    if (!AppConfig.showAutoUpdateToggle) {
      this.startAutoUpdate();
    }
  }

  startAutoUpdate = () => {
    this.eventUpdateIntervalFnId = setInterval(() => {
      if (this.state.pageNumber === 0) this.updateEvents();
    }, this.eventRefreshInterval);
  }

  fetchItems = () => {
    const thisObj = this;
    ApiHelperV2.call(
      { method: 'GET', endPoint: ApiHelperV2.makeUrlPath(['places', this.slug]) },
      function (err, result) {
        if (err) {
          this.setState({
            fetchState: ApiHelperV2.State.ERROR,
            errMsg: Helper.getErrorMsg(err)
          })
          return
        }
        this.setState({
          place: result,
          cams: result.cams,
          statAdjust: result.statAdjust ? result.statAdjust : 0
          //fetchState: ApiHelperV2.State.READY
        })

        if (this.state.selectedCamId) {
          if (result && result.cams.length > 0) {
            let camFound = false;
            for (const c of result.cams) {
              if (c._id === this.state.selectedCamId) {
                camFound = true;
                this.setState({
                  selectedCam: c,
                  urlJpeg: c.urlJpeg,
                  selectedCamId: c._id
                }, () => {
                  this.updateEvents();
                })
              }
            }
            if (!camFound) {
              this.setState({
                fetchState: ApiHelperV2.State.ERROR,
                errMsg: 'Camera not installed at this place. Please contact the customer care.'
              })
            }
          }
        } else if (result && result.cams.length > 0 && !this.state.selectedCam) {
          this.setState({
            selectedCam: result.cams[0],
            urlJpeg: result.cams[0].urlJpeg,
            selectedCamId: result.cams[0]._id
          }, () => {
            this.updateEvents();
          })
        } else {
          this.setState({
            fetchState: ApiHelperV2.State.ERROR,
            errMsg: 'Camera not installed at this place. Please contact the customer care.'
          })
        }
      }.bind(this))
  }

  updateEvents = (action) => {
    this.getCamEvents(action);
    //this.getCamVideos(); TODO: videos not used now
    this.setCamDimensions();
  }

  getCamEvents = (action) => {
    const params = {
      priority: this.eventPriorityValue,
      limit: this.eventsLimit,
    }

    /*const fromEventDateStr = moment(this.state.fromEventDate).format('MM/DD/YYYY, h:mm:ss a')
    const toEventDateStr = moment(this.state.toEventDate).format('MM/DD/YYYY, h:mm:ss a')

    params.fromDateTs = moment(fromEventDateStr, 'MM/DD/YYYY, h:mm:ss a').valueOf()
    params.toDateTs = moment(toEventDateStr, 'MM/DD/YYYY, h:mm:ss a').valueOf()*/

    let fromDateTs = this.state.fromEventDate
    let toDateTs = this.state.toEventDate
    if(this.refreshWithLast24hrs && this.dateDialogClosed) {
      fromDateTs = moment().subtract(1, 'days').valueOf()
      toDateTs = moment().valueOf()
    }

    params.fromDateTs = fromDateTs
    params.toDateTs = toDateTs

    let pageNumber = this.state.pageNumber
    if (action === 'next') {
      if (!this.state.paginate) {
        return
      }
      if (this.fetechedCamEvents && this.fetechedCamEvents.length > 0) {
        pageNumber = pageNumber + 1
        params.pageNumber = pageNumber
      }
    }

    if (action === 'prev') {
      if (this.state.pageNumber === 0) {
        return
      }
      if (this.fetechedCamEvents && this.fetechedCamEvents.length > 0) {
        pageNumber = pageNumber - 1
        params.pageNumber = pageNumber
      }
    }

    if (!action) {
      pageNumber = 0
    }

    const options = {
      method: 'GET',
      endPoint: ApiHelperV2.makeUrlPath(
        ['cams', this.state.selectedCamId, 'events'],
        params),
    }

    ApiHelperV2.call(
      options,
      function (err, result) {
        if (err) {
          this.setState({
            fetchState: ApiHelperV2.State.ERROR,
            errMsg: Helper.getErrorMsg(err)
          })
          return
        }

        this.updateLastSeenTs();

        this.fetechedCamEvents = result.items;
        const parkingEntry = this.state.parkingEntry;
        const parkingEntryTotal = this.state.parkingEntryTotal;

        if (this.state.place && this.state.place.type === 'parking_in_out' && pageNumber === 0) {
          let parkingOutToday = null, parkingInToday = null;
          let parkingOutTotal = null, parkingInTotal = null;
          for (const e of this.fetechedCamEvents) {
            if (e.statInfo && e.statInfo.IN_TODAY !== undefined && parkingInToday === null) {
              parkingInToday = e.statInfo.IN_TODAY
            }
            if (e.statInfo && e.statInfo.OUT_TODAY !== undefined && parkingOutToday === null) {
              parkingOutToday = e.statInfo.OUT_TODAY
            }
            if (e.statInfo && e.statInfo.IN_TOTAL !== undefined && parkingInTotal === null) {
              parkingInTotal = e.statInfo.IN_TOTAL
            }
            if (e.statInfo && e.statInfo.OUT_TOTAL !== undefined && parkingOutTotal === null) {
              parkingOutTotal = e.statInfo.OUT_TOTAL
            }
          }

          if (parkingInToday !== null) {
            parkingEntry.IN = parkingInToday
          }
          if (parkingOutToday !== null) {
            parkingEntry.OUT = parkingOutToday
          }
          if (parkingInTotal !== null) {
            parkingEntryTotal.IN_TOTAL = parkingInTotal
          }
          if (parkingOutTotal !== null) {
            parkingEntryTotal.OUT_TOTAL = parkingOutTotal
          }
          parkingEntry.PARKED = parkingEntryTotal.IN_TOTAL - parkingEntryTotal.OUT_TOTAL + this.state.statAdjust
        }

        if (result.more) {
          this.setState({
            paginate: true
          })
        } else {
          this.setState({
            paginate: false
          })
        }

        let eventLatest = this.state.eventLatest
        if (pageNumber === 0) {
          eventLatest = (this.fetechedCamEvents.length > 0) ? this.fetechedCamEvents[0] : null
        }

        if (this.state.search) {
          this.setState({
            pageNumber: pageNumber,
            eventLatest: eventLatest,
            eventData: this.filterEventsAfterFetch(this.state.search),
            eventsReady: true,
            parkingEntry: parkingEntry,
            parkingEntryTotal: parkingEntryTotal,
            fetchState: ApiHelperV2.State.READY,
            fromEventDate: fromDateTs,
            toEventDate: toDateTs,
          })
        } else {
          this.setState({
            pageNumber: pageNumber,
            eventLatest: eventLatest,
            eventData: result.items,
            eventsReady: true,
            parkingEntry: parkingEntry,
            parkingEntryTotal: parkingEntryTotal,
            fetchState: ApiHelperV2.State.READY,
            fromEventDate: fromDateTs,
            toEventDate: toDateTs,
          })
        }
      }.bind(this))
  }

  getCamVideos = () => {
    const params = {
      priority: this.eventPriorityValue,
      limit: this.eventsLimit,
    }

    /*const fromEventDateStr = moment(this.state.fromEventDate).format('MM/DD/YYYY')
    const toEventDateStr = moment(this.state.toEventDate).format('MM/DD/YYYY')

    params.fromDateTs = moment(fromEventDateStr, 'MM/DD/YYYY').valueOf()
    params.toDateTs = moment(toEventDateStr, 'MM/DD/YYYY').valueOf()*/

    let fromDateTs = this.state.fromEventDate
    let toDateTs = this.state.toEventDate
    if(this.refreshWithLast24hrs && this.dateDialogClosed) {
      fromDateTs = moment().subtract(1, 'days').valueOf()
      toDateTs = moment().valueOf()
    }

    params.fromDateTs = fromDateTs
    params.toDateTs = toDateTs

    const options = {
      method: 'GET',
      endPoint: ApiHelperV2.makeUrlPath(
        ['cams', this.state.selectedCamId, 'videos'],
        params),
    }

    ApiHelperV2.call(
      options,
      function (err, result) {
        if (err) {
          this.setState({
            fetchState: ApiHelperV2.State.ERROR,
            errMsg: Helper.getErrorMsg(err)
          })
          return
        }

        this.fetechedCamVideos = result;
        if (this.state.search) {
          this.setState({
            //videoData: this.filterVideosAfterFetch(this.state.search),
            videosReady: true,
          })
        } else {
          this.setState({
            //videoData: result,
            fromEventDate: fromDateTs,
            toEventDate: toDateTs,
            videosReady: true,
          })
        }
      }.bind(this))
  }

  render() {
    if (this.state.fetchState === ApiHelper.State.LOADING) {
      return UiHelper.componentLoadingView();
    } else if (this.state.fetchState === ApiHelper.State.ERROR) {
      return UiHelper.errorView(this);
    } else {
      return this.readyView();
    }
  }

  onCamSelect = event => {
    for (const cam of this.state.cams) {
      if (cam._id === event.target.value) {
        this.setState({
          [event.target.name]: event.target.value,
          selectedCam: cam,
          urlJpeg: cam.urlJpeg,
        }, () => { this.updateEvents() });
        let url = '/places/' + this.slug + '?camId=' + cam._id
        if(this.showLiveStreamsStile === 'true') {
          url = url + '&showlive=true'
        }
        this.props.history.replace(url)
        break;
      }
    }
  };

  generateSelectField = (formField, data) => {
    return (
      <div className={css(Styles.selectInnerContainer)}>
        <FormControl className={css(Styles.selectInnerContainer)}>
          {/*TODO: fix overlapping<InputLabel>{formField.label}</InputLabel>*/}
          <Select
            name={formField.key}
            value={this.state[formField.key]}
            onChange={this.onCamSelect}
          >
            {data.map(item => {
              return (
                <MenuItem value={item._id}>{item.name}</MenuItem>
              )
            })}
          </Select>
        </FormControl>
      </div>
    )
  }

  onDateSelectorClick = () => {
    this.stopAutoUpdate()
  }

  generateDateField = (formField) => {
    return (
      <div className={css(Styles.selectDateInnerContainer)}>
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <DateTimePicker
            onOpen={() => this.onDateSelectorClick()}
            id={formField.key}
            name={formField.key}
            className={css(Styles.selectDateInnerContainer)}
            value={this.state[formField.key] ? momentTz(this.state[formField.key]) : null}
            onChange={e => this.onTimeChange(e, formField.key)}
            onClose={() => this.onDateDialogClose()}
            label={formField.label}
            disableFuture
          />
        </MuiPickersUtilsProvider>
      </div>
    )
  }

  onDateDialogClose = () => {
    this.dateDialogClosed = true
    this.enableAutoUpdate();
  }

  onTimeChange = (e, key) => {
    this.refreshWithLast24hrs = false
    this.setState({ [key]: moment(e).valueOf() }, () => { this.updateEvents() });
  }

  eventDialog = (item, index) => {
    this.setState({
      eventDialog: true,
      eventIndex: index
    })
    this.stopAutoUpdate();
  }

  stopAutoUpdate = () => {
    if (this.state.autoUpdate && this.eventUpdateIntervalFnId) {
      clearInterval(this.eventUpdateIntervalFnId);
      this.setState({
        autoUpdate: !this.state.autoUpdate,
        restoreUpdate: true
      })
    }
  }

  enableAutoUpdate = () => {
    if (this.state.restoreUpdate) {
      this.eventUpdateIntervalFnId = setInterval(() => {
        if (this.state.pageNumber === 0) this.updateEvents();
      }, this.eventRefreshInterval);
      this.setState({
        autoUpdate: !this.state.autoUpdate,
        restoreUpdate: false
      })
    }
  }

  eventVideoDialog = (item, index) => {
    this.setState({
      eventVideoDialog: true,
      eventIndex: index
    })
    this.stopAutoUpdate()
  }

  dialogVideoClose = () => {
    this.setState({ eventVideoDialog: false })
    this.enableAutoUpdate();
  }

  dialogVideoLast = () => {
    const lastValue = this.state.videoData.length - 1
    this.setState({ eventIndex: lastValue })
  }

  dialogClose = (refetch) => {
    this.setState({ eventDialog: false })
    this.enableAutoUpdate();
    //this.updateEvents()
  }

  findEventVideo = (event) => {
    let index = 0;
    for (const video of this.state.videoData) {
      if (video.time < event.event_time) {
        return index;
      }
      index = index + 1;
    }
    return -1;
  }

  dialogMsgClose = () => {
    this.setState({ dialogMsg: false })
  }

  dialogVideoPlay = (item) => {
    const videoIndex = this.findEventVideo(item);
    if (videoIndex < 0) {
      this.setState({ eventDialog: false, dialogMsg: true })
      this.enableAutoUpdate()
    } else {
      this.setState({ eventDialog: false, eventVideoDialog: true, eventIndex: videoIndex })
    }
  }

  setEventData = (index, priority) => {
    const eventData = this.state.eventData;
    eventData[index].priority = priority;
    this.setState({
      eventData: eventData
    })
  }

  eventButton = () => {
    this.setState({ event: true, live: false });
  }

  liveButton = () => {
    this.setState({
      event: false,
      live: true
    }, () => this.resetJcrop());
  }

  eventsButton = () => {
    this.setState({ events: true, video: false });
  }

  videoButton = () => {
    this.setState({ events: false, video: true });
  }

  filterVideosAfterFetch = (searchTerm) => {
    const videos = this.fetechedCamVideos.filter((e) => {
      const searchTermRegExp = new RegExp(searchTerm, 'gi');
      let inTime = false
      if (e) {
        if (e.time) {
          inTime = searchTermRegExp.test(moment(e.time).format('MMM DD, YYYY, h:mm:ss A'));
        }
      }

      return (inTime);
    });
    return videos
  }

  filterEventsAfterFetch = (searchTerm) => {
    const filteredEvents = this.fetechedCamEvents.filter((e) => {
      const searchTermRegExp = new RegExp(searchTerm, 'gi');
      let inName = false, inDescription = false, inType = false, inTime = false, inPriority = false;
      if (e) {
        if (searchTerm &&
          (searchTerm.startsWith('p:') || searchTerm.startsWith('P:'))) {
          let searchTermPr = '';
          if (searchTerm.startsWith('p:')) {
            searchTermPr = searchTerm.replace('p:', '');
          } else if (searchTerm.startsWith('P:')) {
            searchTermPr = searchTerm.replace('P:', '');
          }
          const searchTermPrRegExp = new RegExp(searchTermPr, 'gi');
          inPriority = searchTermPrRegExp.test(String(e.priority));
        } else {
          if (e.name) {
            inName = searchTermRegExp.test(e.name);
          }

          if (e.description) {
            inDescription = searchTermRegExp.test(e.description);
          }

          if (e.type) {
            inType = searchTermRegExp.test(e.type);
          }

          if (e.event_time) {
            inTime = searchTermRegExp.test(moment(e.event_time).format('MMM DD, YYYY, h:mm:ss A'));
          }
        }
      }

      return (inName || inDescription || inType || inTime || inPriority);
    });
    //this.setState({ eventData: filteredEvents })
    return filteredEvents
  }

  generateText = e => {
    this.setState({ [e.target.name]: e.target.value });
    this.setState({
      eventData: this.filterEventsAfterFetch(e.target.value),
      //videoData: this.filterVideosAfterFetch(e.target.value)
    })
  }

  generateTextFieldSearch = (formField) => {
    return (
      <TextField
        id={formField.key}
        placeholder={formField.label}
        name={formField.key}
        className={css(Styles.inputCss)}
        value={this.state[formField.key]}
        onChange={e => this.generateText(e)}
        margin='normal'
        type={formField.type}
        InputProps={{
          classes: {
            root: css(Styles.textFieldContent),
            input: css(Styles.input),
          }
        }}
        InputLabelProps={{
          classes: {
            root: css(Styles.textFieldContent),
            animated: css(Styles.animated),
          }
        }}
      />
    )
  }

  generateTextField = (formField, data) => {
    let disabled = '';
    let validity = {};
    validity = this.state.formFieldsValidity;

    if (this.state.dialogAction === 'delete') {
      if (formField.key === 'roiDelete') {
        disabled = false
      } else {
        disabled = true
      }
    } else {
      disabled = false
    }

    return (
      <TextField
        id={formField.key}
        label={formField.label}
        name={formField.key}
        className={css(Styles.inputCssROI)}
        value={this.state[formField.key]}
        onChange={e => this.change(e)}
        margin='normal'
        type={formField.type}
        helperText={this.state.dialogAction === 'delete' ? '' :
          validity[formField.key] ? '' : this.getFieldErrorMsg(formField.key)}
        error={this.state.dialogAction === 'delete' ? '' : !validity[formField.key]}
        disabled={disabled}
        InputProps={{
          classes: {
            root: css(Styles.textFieldContentInput),
          }
        }}
        InputLabelProps={{
          classes: {
            root: css(Styles.textFieldContent),
            focused: css(Styles.focused),
          }
        }}
      />
    )
  }

  onROIDelete = () => {
    this.setState({
      dialogAction: 'delete',
    })
  }

  dialogCloseROI = () => {
    this.resetJcrop()
    this.setState({
      roiDialog: false,
      roiTitle: '',
      roiValue: '',
    })
  }

  validateFields = () => {
    const item = this.state;
    const formFieldsValidity = this.state.formFieldsValidity;
    if (!item.roiTitle || item.roiTitle.length === 0) {
      formFieldsValidity.roiTitle = false;
    } else {
      formFieldsValidity.roiTitle = true;
    }
    if (!item.roiValue || item.roiValue.length === 0) {
      formFieldsValidity.roiValue = false;
    } else {
      formFieldsValidity.roiValue = true;
    }

    this.setState({
      formFieldsValidity: formFieldsValidity
    });

    for (const key in formFieldsValidity) {
      if (formFieldsValidity[key] === false) {
        return false
      }
    }
    this.targetImageHeight = document.getElementById('target-image').height;
    this.targetImageWidth = document.getElementById('target-image').width;
    const blc = JcropService.getBottomLeftCoorindates(this.state.widget, this.targetImageHeight, this.targetImageWidth, this.state.selectedCam.streamContentHeight, this.state.selectedCam.streamContentWidth)
    const tlc = JcropService.getTopRightCoorindates(this.state.widget, this.targetImageHeight, this.targetImageWidth, this.state.selectedCam.streamContentHeight, this.state.selectedCam.streamContentWidth)

    const apiBody = {
      key: item.roiTitle,
      value: item.roiValue,
      bottomLeftCoords: blc,
      topRightCoords: tlc,
    }
    return apiBody;
  }

  updateLastSeenTs = () => {
    const options = {
      method: 'PUT',
      endPoint: ApiHelperV2.makeUrlPath(['cams', this.state.selectedCam._id]),
      jsonBody: {
        camData: { lastSeenTs: moment().valueOf() } //TODO: this can be done from backend only
      }
    }
    ApiHelperV2.call(options, function (err, data) {
      if (err) return
    }.bind(this))
  }

  submit = () => {
    const apiBody = this.validateFields();
    let options = {};
    if (!apiBody) {
      return
    }
    if (!this.state.widget.options.id) {
      options = {
        method: 'POST',
        endPoint: ApiHelperV2.makeUrlPath(['cams', this.state.selectedCam._id, 'rois']),
        jsonBody: {
          camData: apiBody
        }
      }
    } else {
      options = {
        method: 'PUT',
        endPoint: ApiHelperV2.makeUrlPath(['cams', this.state.selectedCam._id, 'rois', this.state.widget.options.id]),
        jsonBody: {
          camData: apiBody
        }
      }
    }

    ApiHelperV2.call(options, function (err, data) {
      if (err) {
        const msg = err.message ? err.message : 'An error occurred, please try again. Contact customer care if problem persists.';
        this.setState({
          errMsg: msg,
          errCode: err.respCode,
        })
        return
      } else {
        this.fetchItems()
        this.setState({
          roiDialog: false,
          roiTitle: '',
          roiValue: ''
        })
      }
    }.bind(this))
  }

  deleteROI = () => {
    if (this.state.roiDelete === 'DELETE') {
      this.setState({
        showDeleteWarning: false
      })
    } else {
      this.setState({
        showDeleteWarning: true
      })
      return
    }

    const options = {
      method: 'DELETE',
      endPoint: ApiHelperV2.makeUrlPath(['cams', this.state.selectedCam._id, 'rois', this.state.widget.options.id])
    }
    ApiHelperV2.call(options, function (err, data) {
      if (err) {
        const msg = err.message ? err.message : 'An error occurred, please try again. Contact customer care if problem persists.';
        this.setState({
          errMsg: msg,
          errCode: err.respCode,
        })
        return
      } else {
        this.fetchItems()
        this.setState({
          roiDialog: false,
          roiTitle: '',
          roiValue: ''
        })
      }
    }.bind(this))
  }

  change = e => {
    this.setState({ [e.target.name]: e.target.value });
  }

  getFieldErrorMsg = (formFieldKey) => {
    if (this.state.formFieldErrMsg[formFieldKey]) {
      return this.state.formFieldErrMsg[formFieldKey]
    }
    return '*Required'
  }

  dialogFunction(dialogAction, title) {
    this.targetImageHeight = document.getElementById('target-image').height;
    this.targetImageWidth = document.getElementById('target-image').width;
    const blc = JcropService.getBottomLeftCoorindates(this.state.widget, this.targetImageHeight, this.targetImageWidth, this.state.selectedCam.streamContentHeight, this.state.selectedCam.streamContentWidth)
    const tlc = JcropService.getTopRightCoorindates(this.state.widget, this.targetImageHeight, this.targetImageWidth, this.state.selectedCam.streamContentHeight, this.state.selectedCam.streamContentWidth)
    return (
      <Dialog
        onClose={this.dialogCloseROI}
        open={this.state.roiDialog}
        scroll='paper'
        classes={{
          paperWidthSm: css(Styles.dialog),
          scrollPaper: css(Styles.scrollPaper)
        }}
      >
        <DialogTitle className={css(Styles.dialogTitle)}>
          <p className={css(Styles.dialogTitleContent)}>{title}</p>
        </DialogTitle>
        <DialogContent className={css(Styles.dialogContent)}>
          <div className={css(Styles.fieldsContainer)}>
            {this.generateTextField(this.orgFields.roiTitle)}
            {this.generateTextField(this.orgFields.roiValue)}
          </div>
          <div className={css(Styles.fieldsContainerCord)}>
            <p className={css(Styles.fieldsContainerCoContent)}>
              Bottom left co-ordinates({blc[0]}, {blc[1]})</p>
            <p className={css(Styles.fieldsContainerCoContent)}>
              Top right co-ordinates({tlc[0]}, {tlc[1]})</p>
          </div>
          {dialogAction === 'delete' &&
            <div className={css(Styles.fieldsContainer)}>
              {this.generateTextField(this.orgFields.roiDelete)}
            </div>
          }
        </DialogContent>
        <DialogActions className={css(Styles.dialogActions)}>
          <Button
            variant='contained'
            onClick={this.state.dialogAction === 'delete' ? e => this.deleteROI() : e => this.submit()}
            className={css(Styles.actionButton)}>
            {this.state.dialogAction === 'delete' ? 'Delete' : 'Submit'}
          </Button>
          <Button
            variant='contained'
            onClick={() => this.dialogCloseROI()}
            className={css(Styles.actionButton)}>
            Cancel
          </Button>
          <div className={css(Styles.fillSpace)}></div>
          <Fab
            color='secondary'
            aria-label='delete'
            size={'small'}
            onClick={this.onROIDelete}>
            <Icon>delete</Icon>
          </Fab>
        </DialogActions>
        {this.state.showDeleteWarning && this.state.dialogAction === 'delete' &&
          <p className={css(Styles.deleteMsg)}>*Enter DELETE Correctly</p>
        }
      </Dialog>
    );
  }

  openRoiDialog(widget) {
    let formData = null;
    //console.log('widget.options.id', widget)
    if (widget.options.id) {
      formData = JcropService.findROI(widget.options.id, this.state.selectedCam.rois);
      this.setState({
        roiDialog: true,
        dialogAction: 'edit',
        dialogTitle: 'Edit ROI',
        widget: widget,
        roiTitle: formData.key,
        roiValue: formData.value
      })
    } else {
      this.setState({ roiDialog: true, dialogAction: 'add', dialogTitle: 'Add ROI', widget: widget })
    }
  }


  setCamDimensions() {
    if (this.state.selectedCam.streamContentHeight && this.state.selectedCam.streamContentWidth) {
      this.resetJcrop();
      this.setState({ showROI: true })
    } else {
      this.setState({ showROI: false })
      this.setState({ slideChecked: false })
    }
  }

  refresh() {
    //console.log('Auto refreshing')
    this.refreshWithLast24hrs = true
    this.setState({
      fromEventDate: moment().subtract(1, 'days').valueOf(),
      toEventDate: moment().valueOf()
    }, () => this.updateEvents())
  }

  resetJcrop() {
    if (this.state.slideChecked) {
      JcropService.dettachJcrop(this.jcrop);
      this.jcrop = null;
      this.attachJcrop();
    }
  }

  onAutoUpdateChange = (event) => {
    if (event.target.checked) {
      this.eventUpdateIntervalFnId = setInterval(() => {
        this.updateEvents();
      }, this.eventRefreshInterval);
    } else {
      if (this.eventUpdateIntervalFnId) {
        clearInterval(this.eventUpdateIntervalFnId);
      }
    }
    this.setState({ autoUpdate: event.target.checked })
  }

  componentWillUnmount() {
    if (this.updateImageIntervalFnId) {
      clearInterval(this.updateImageIntervalFnId);
    }
    if (this.eventUpdateIntervalFnId) {
      clearInterval(this.eventUpdateIntervalFnId);
    }
    JcropService.dettachJcrop(this.jcrop);
    this.jcrop = null;
  }

  cropChange(widget, e) {
    //console.log('cropChange');
    this.openRoiDialog(widget);
  }

  cropRemove(widget, e) {
    //console.log('cropRemove');
  }

  attachJcrop() {
    if (!document.getElementById('target-image')) {
      return
    }
    this.jcrop = Jcrop.attach('target-image', {
      multi: true
    });
    this.targetImageHeight = document.getElementById('target-image').height;
    this.targetImageWidth = document.getElementById('target-image').width;
    JcropService.loadMarkers(
      this.jcrop,
      this.state.selectedCam.rois,
      this.targetImageHeight,
      this.targetImageWidth,
      this.state.selectedCam.streamContentHeight,
      this.state.selectedCam.streamContentWidth
    );

    this.jcrop.listen('crop.change', (widget, e) => {
      this.cropChange(widget, e);
    });

    this.jcrop.listen('crop.remove', (widget, e) => {
      this.cropRemove(widget, e);
    });
  }

  onToggle(event) {
    this.setState({ slideChecked: event })
    if (event) {
      this.setState({ viewMode: 'ROI ON' })
      this.attachJcrop();
    } else {
      this.setState({ viewMode: 'ROI OFF' })
      JcropService.dettachJcrop(this.jcrop);
      this.jcrop = null;
    }
  }

  liveStreamChange = name => event => {
    this.setState({ [name]: event.target.checked });
    this.onToggle(event.target.checked)
  };

  closeStatDialog = () => {
    this.setState({
      statDialog: false,
    })
  }

  openStatDialog = () => {
    //this.oldParkingEntryTotal = this.state.parkingEntryTotal;
    this.setState({
      parkedVal: this.state.parkingEntry.PARKED,
      statDialog: true,
    })
  }

  statDialog() {
    const statField = this.statFields.parkedVal;
    return (
      <Dialog
        onClose={this.closeStatDialog}
        open={this.state.statDialog}
        scroll='paper'
        classes={{
          paperWidthSm: css(Styles.dialog),
          scrollPaper: css(Styles.scrollPaper)
        }}
      >
        <DialogTitle className={css(Styles.dialogTitle)}>
          <p className={css(Styles.dialogTitleContent)}>Set value of PARKED</p>
        </DialogTitle>
        <DialogContent className={css(Styles.dialogContent)}>
          <div className={css(Styles.statAdjustInfo)}>
            <p className={css(Styles.statAdjustContainerTitle)}>IN (Total)</p>
            <p className={css(Styles.statAdjustVal)}>{this.state.parkingEntryTotal.IN_TOTAL}</p>
          </div>
          <div className={css(Styles.statAdjustInfo)}>
            <p className={css(Styles.statAdjustContainerTitle)}>OUT (Total)</p>
            <p className={css(Styles.statAdjustVal)}>{this.state.parkingEntryTotal.OUT_TOTAL}</p>
          </div>
          <div className={css(Styles.statAdjustInfo)}>
            <p className={css(Styles.statAdjustContainerTitle)}>Stat correction</p>
            <p className={css(Styles.statAdjustVal)}>{this.state.statAdjust}</p>
          </div>

          <div className={css(Styles.fieldsContainer)}>
            <TextField
              id={statField.key}
              label={statField.label}
              name={statField.key}
              className={css(Styles.inputCssROI)}
              value={this.state[statField.key]}
              onChange={e => this.change(e)}
              margin='normal'
              type={statField.type}
              InputProps={{
                classes: {
                  root: css(Styles.textFieldContentInput),
                }
              }}
              InputLabelProps={{
                classes: {
                  root: css(Styles.textFieldContent),
                  focused: css(Styles.focused),
                }
              }}
            />
          </div>
        </DialogContent>
        <DialogActions className={css(Styles.dialogActions)}>
          <Button
            variant='contained'
            onClick={e => this.submitStat()}
            className={css(Styles.actionButton)}>
            Submit
          </Button>
          <Button
            variant='contained'
            onClick={() => this.closeStatDialog()}
            className={css(Styles.actionButton)}>
            Cancel
          </Button>
        </DialogActions>
        {this.state.statFieldErrMsg &&
          <p className={css(Styles.errMsg)}>{this.state.statFieldErrMsg}</p>
        }
      </Dialog>
    );
  }

  /*updateStatAdjustVal = (delta) => {
    const newStatAdjust = this.state.statAdjust + delta
    this.setState({
      statUpdateInProcess: true
    })

    const payload = {
      placeData: {
        statAdjust: newStatAdjust
      }
    }
    const options = {
      method: 'PUT',
      endPoint: ApiHelperV2.makeUrlPath(['places', this.state.place._id]),
      jsonBody: payload
    }
    ApiHelperV2.call(options, function (err, data) {
      if (err) {
        const msg = err.message ? err.message : 'An error occurred, please try again. Contact customer care if problem persists.';
        this.setState({
          //errMsg: msg,
          //errCode: err.respCode,
          statUpdateInProcess: false,
        })
        return
      }

      const parkingEntry = this.state.parkingEntry
      parkingEntry.PARKED = parkingEntry.IN - parkingEntry.OUT + newStatAdjust

      this.setState({
        statAdjust: newStatAdjust,
        parkingEntry: parkingEntry,
        statUpdateInProcess: false,
      })
    }.bind(this))
  }*/

  isValidStatField = () => {
    //const SCORE_REGEXP = /^\d?$/i;
    const SCORE_REGEXP = /^\d+$/i;

    if (!SCORE_REGEXP.test(this.state.parkedVal)) {
      const formFieldErrMsg = this.state.formFieldErrMsg;
      this.setState({
        statFieldErrMsg: 'Not a valid number'
      })
      return false
    }
    return true
  }

  submitStat = () => {

    //const newStatAdjust = Number(this.state.parkedVal) - (this.oldParkingEntryTotal.IN_TOTAL - this.oldParkingEntryTotal.OUT_TOTAL)
    const newStatAdjust = Number(this.state.parkedVal) - (this.state.parkingEntryTotal.IN_TOTAL - this.state.parkingEntryTotal.OUT_TOTAL)

    this.setState({
      statUpdateInProcess: true
    })

    if (!this.isValidStatField()) {
      this.setState({
        statFieldErrMsg: 'Not a valid number',
        statUpdateInProcess: false,
      })
      return
    }

    const payload = {
      placeData: {
        statAdjust: newStatAdjust
      }
    }
    const options = {
      method: 'PUT',
      endPoint: ApiHelperV2.makeUrlPath(['places', this.state.place._id]),
      jsonBody: payload
    }
    ApiHelperV2.call(options, function (err, data) {
      if (err) {
        const msg = err.message ? err.message : 'An error occurred, please try again. Contact customer care if problem persists.';
        this.setState({
          statFieldErrMsg: msg,
          statUpdateInProcess: false,
        })
        return
      }

      const parkingEntry = this.state.parkingEntry
      const parkingEntryTotal = this.state.parkingEntryTotal
      parkingEntry.PARKED = parkingEntryTotal.IN_TOTAL - parkingEntryTotal.OUT_TOTAL + newStatAdjust

      this.setState({
        statAdjust: newStatAdjust,
        parkingEntry: parkingEntry,
        statUpdateInProcess: false,
        statDialog: false,
        statFieldErrMsg: null
      })
    }.bind(this))
  }

  getCardFooter = (k) => {
    if (k === 'PARKED') {
      return (
        <div className={css(Styles.statAdjustContainer)}>
          <div style={{ flex: 1 }}></div>
          <Fab
            color='secondary'
            classes={{
              root: css(Styles.statAdjustIconContainer),
            }}
            aria-label='delete'
            size={'small'}
            onClick={() => this.openStatDialog()}>
            <Icon className={css(Styles.statAdjustIcon)}>edit</Icon>
          </Fab>
          {/*<div className={css(Styles.statAdjustContainer)}>
            <Fab
              color='secondary'
              classes={{
                root: css(Styles.statAdjustIconContainer),
              }}
              aria-label='delete'
              size={'small'}
              onClick={() => this.updateStatAdjustVal(-1)}>
              <Icon className={css(Styles.statAdjustIcon)}>remove_cirlce</Icon>
            </Fab>
            {this.state.statUpdateInProcess &&
              <div className={css(Styles.statAdjustVal)}>
                <CircularProgress size={26} className={css(Styles.progress)} />
              </div>
            }
            {!this.state.statUpdateInProcess &&
              <p className={css(Styles.statAdjustVal)}>{this.state.statAdjust}</p>
            }
            <Fab
              classes={{
                root: css(Styles.statAdjustIconContainer),
              }}
              color='secondary'
              aria-label='increment'
              size={'small'}
              onClick={() => this.updateStatAdjustVal(1)}>
              <Icon className={css(Styles.statAdjustIcon)}>add_cirlce</Icon>
            </Fab>
            </div>*/}
        </div>
      )
    } else {
      return null
    }
  }

  getEventCount = () => {
    return this.state.pageNumber + 1
    /*let start, end;
    start = this.state.pageNumber * this.eventsLimit
    end = this.state.pageNumber * this.eventsLimit + this.fetechedCamEvents.length
    if (this.fetechedCamEvents.length > 0) {
      start = start + 1
    }
    return (start + ' to ' + end)*/
  }

  readyView() {

    return (
      <div className={css(Styles.container)}>
        {this.state.eventLatest &&
          this.state.eventLatest.stat &&
          this.state.place &&
          this.state.place.type !== 'parking_in_out' &&
          Object.keys(this.state.eventLatest.stat).length > 0 &&
          <Grid container spacing={16} className={css(Styles.statContainer)}>
            {Object.keys(this.state.eventLatest.stat).map((k, index) => (
              <StatCard
                key={k}
                text={k}
                subText={this.state.eventLatest.stat[k]}
                cardIndex={index}
              />
            ))}
          </Grid>
        }
        {this.state.place &&
          this.state.place.type === 'parking_in_out' &&
          <Grid container spacing={16} className={css(Styles.statContainer)}>
            {Object.keys(this.state.parkingEntry).map((k, index) => (
              <StatCard
                key={k}
                text={k}
                subText={this.state.parkingEntry[k]}
                cardIndex={index}
                cardFooter={() => this.getCardFooter(k)}
              />
            ))}
          </Grid>
        }

        <div className={css(Styles.paginationContainer)}>
          <Link to={{ pathname: '/places' }} className={css(CommonStyles.navLink)} >
            <Icon className={css(CommonStyles.navIcon)} color='secondary' >
              business
            </Icon>
            <p className={css(CommonStyles.navTitle)}>Places</p>
          </Link>
          {this.showLiveStreamsStile === 'true' &&
            <Link to={{ pathname: '/places/' + this.slug + '/cams' }} className={css(CommonStyles.navLink)} >
              <Icon className={css(CommonStyles.navIcon)} color='secondary' >
                videocam
              </Icon>
              <p className={css(CommonStyles.navTitle)}>Live streams</p>
            </Link>
          }
          {this.state.place &&
            <p className={css(Styles.headerContainer)}>{this.state.place.name}</p>
          }
          {(this.state.paginate || this.state.pageNumber !== 0) &&
            <div className={css(Styles.paginationContent)}>
              <Tooltip title='Previous'>
                <IconButton disabled={this.state.pageNumber === 0}>
                  <Icon className={css(Styles.refreshIcon)} color='secondary' onClick={() => this.updateEvents('prev')}>
                  navigate_before
                  </Icon>
                </IconButton>
              </Tooltip>
              <p className={css(Styles.pageNumber)}>{this.getEventCount()}</p>
              <Tooltip title='Next'>
                <IconButton disabled={!this.state.paginate}>
                  <Icon className={css(Styles.refreshIcon)} color='secondary' onClick={() => this.updateEvents('next')}>
                  navigate_next
                  </Icon>
                </IconButton>
              </Tooltip>
            </div>
          }
        </div>

        <div className={css(Styles.outerContainer)}>
          <div className={css(Styles.formOuterContainer)} >
            <div className={css(Styles.formContainer)}>
              <div className={css(Styles.formInnerContainer)}>
              </div>
              <div className={css(Styles.formSelectFirstContainer)}>
                {this.generateSelectField(this.placeFields.selectCam, this.state.cams)}
              </div>
            </div>
            <div className={css(Styles.formDateContainer)}>
              <div className={css(Styles.formSelectFirstContainer)}>
                {this.generateDateField(this.placeFields.fromEventDate)}
              </div>
              <div className={css(Styles.marginRight)}></div>
              <div className={css(Styles.formSelectFirstContainer)}>
                {this.generateDateField(this.placeFields.toEventDate)}
              </div>
            </div>
            <div className={css(Styles.eventActionContainer)}>
              <Button className={this.state.live ? css(Styles.eventButton) : css(Styles.liveButton)}
                onClick={e => this.liveButton()}>
                Live Stream
              </Button>
              <Button className={this.state.event ? css(Styles.eventButton) : css(Styles.liveButton)}
                onClick={e => this.eventButton()}>
                Last Event
              </Button>
            </div>
            {this.state.event &&
              <div className={css(Styles.eventContainer)}>
                <div className={css(Styles.eventContainerHeader)}>
                  {/*<div className={css(Styles.refreshContainer)}>
                    <Icon className={css(Styles.refreshIcon)} color='secondary'>
                      loop
                    </Icon>
                  </div>*/}
                </div>
                <div className={css(Styles.latestEventContainerImg)}>
                  <img
                    src={this.state.eventLatest ? this.state.eventLatest.image : require('../../assets/images/error-new.png')}
                    className={css(Styles.eventImg)}></img>
                </div>
              </div>
            }
            {this.state.live &&
              <div className={css(Styles.eventContainer)}>
                <div className={css(Styles.eventContainerHeader)}>
                  <div className={css(Styles.refreshContainer)}>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={this.state.liveStream}
                          onChange={this.liveStreamChange('liveStream')}
                          value='liveStream'
                        />
                      }
                      label={this.state.viewMode}
                    />

                    {/* <Icon className={css(Styles.refreshIcon)} color='secondary' onClick={e => this.downloadDialog()}>
                  loop
                  </Icon> */}
                  </div>
                </div>
                <div className={css(Styles.eventContainerImg)}>
                  {this.state.selectedCam && this.state.selectedCam.urlJpeg &&
                    <LiveImage
                      urlJpeg={this.state.urlJpeg} />
                  }
                  {this.state.showROI && this.state.selectedCam.urlVideo &&
                    <div style={{ width: '100%', height: 'auto', position: 'absolute' }}>
                      <img
                        style={{ width: '100%', height: 'auto' }}
                        id='target-image'
                        src={require('../../assets/images/16-9-image.png')} />
                    </div>
                  }
                  {this.state.selectedCam && !this.state.selectedCam.urlJpeg && this.state.selectedCam.urlVideo &&
                    <video
                      style={{ width: '100%', height: 'auto' }}
                      // #videoPlayer
                      //src={require('../../assets/video.mp4')}
                      src={this.state.selectedCam.urlVideo}
                      type='video/mp4'
                      controls
                      autoplay='autoplay'
                      controlsList='nodownload'
                      className={css(Styles.eventContainerVidLive)}
                    // (error)="videoLoadErrHandler()"
                    // (canplay) = "canPlayVideo()"
                    >
                    </video>
                  }
                </div>
              </div>
            }
          </div>
          <div className={css(Styles.formSecondOuterContainer)} >
            <div className={css(Styles.eventContainer)}>
              <div className={css(Styles.eventContainerHeader)}>
                <p className={css(Styles.headerContainer)}>Events</p>
                <div className={css(Styles.refreshContainer)}>
                  {this.generateTextFieldSearch(this.placeFields.search)}
                  {AppConfig.showAutoUpdateToggle &&
                    < FormControlLabel
                      control={
                        <Switch
                          checked={this.state.autoUpdate}
                          onChange={this.onAutoUpdateChange}
                        //value={this.state.autoUpdate ? 'Auto' : 'Manual'}
                        />
                      }
                      classes={{
                        label: css(Styles.formControlLabel),
                      }}
                      label={this.state.autoUpdate ? 'Auto' : 'Manual'}
                    />
                  }
                  <Icon className={css(Styles.refreshIcon)} color='secondary' onClick={e => this.refresh()}>
                    loop
                  </Icon>
                </div>
              </div>
              <Divider className={css(Styles.divider)} />
              {/*<div className={css(Styles.eventActionContainer)}>
                <Button className={this.state.events ? css(Styles.eventButton) : css(Styles.videoButton)}
                  onClick={e => this.eventsButton()}>
                  EVENTS
                </Button>
                <Button className={this.state.video ? css(Styles.eventButton) : css(Styles.videoButton)}
                  onClick={e => this.videoButton()}>
                  VIDEOS
                </Button>
              </div>
              <Divider className={css(Styles.eventsDivider)} />
              */}
              {this.state.events &&
                <EventList
                  eventsReady={this.state.eventsReady}
                  data={this.state.eventData}
                  eventDialog={this.eventDialog} />
              }
              {this.state.video &&
                <EventVideoList
                  videosReady={this.state.videosReady}
                  data={this.state.videoData}
                  eventVideoDialog={this.eventVideoDialog} />
              }
            </div>
            {this.state.eventDialog &&
              <EventDialogFunction
                dialogClose={this.dialogClose}
                eventDialog={this.state.eventDialog}
                eventData={this.state.eventData}
                eventIndex={this.state.eventIndex}
                dialogEditClose={this.dialogEditClose}
                priority={this.placeData.priorityValues}
                dialogVideo={this.dialogVideoPlay}
                setEventData={this.setEventData}
                cam={this.state.selectedCam}
              />
            }
            {this.state.eventVideoDialog &&
              <EventVideoDialogFunction
                dialogClose={this.dialogVideoClose}
                eventDialog={this.state.eventVideoDialog}
                videoData={this.state.videoData}
                eventIndex={this.state.eventIndex}
              />
            }
            <DialogMsg
              dialogClose={this.dialogMsgClose}
              eventDialog={this.state.dialogMsg}
              title='Video' desc='Event Video not Found' />
          </div>
          {this.state.roiDialog &&
            this.dialogFunction(this.state.dialogAction, this.state.dialogTitle)
          }
          {this.state.statDialog &&
            this.statDialog()
          }
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/screens/ClientPlace/ClientPlacesDetails.js